import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportCostSettlement, _ImportDeclaration, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { NationalizationProcessItemsByImportDM } from "../NationalizationProcessItems/NationalizationProcessItemsByImportDM";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const DLC001 = ({ configProcedure }: Props) => {

    const ImportDeclaration = useDataBean(_NationalizationProcessGeneralInfo);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });



    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            ImportDeclaration.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        ImportDeclaration.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(ImportDeclaration.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: ImportDeclaration.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }


        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(ImportDeclaration.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        ImportDeclaration.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const createvdos = () => {
        ImportDeclaration.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItemvdos()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        ImportDeclaration.instance.updateNationalizationProcessGeneralInfo(ImportDeclaration.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    const editaItemvdos = () => {

        ImportDeclaration.instance.updateNationalizationProcessGeneralInfo(ImportDeclaration.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                ImportDeclaration.setBean(resp);
                // configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo, State: 1 });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-12">

                        <SelectAdquisitionContract data={{ IDAccount: ImportDeclaration.bean.IDAccount }} idSelector={ImportDeclaration.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    {/* <div className="col-md-6">
                        <InputDate name="ImportDeclarationDateDM" label="Fecha de declaración de importación" value={ImportDeclaration.bean.ImportDeclarationDateDM} setDate={(e: any) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, "ImportDeclarationDateDM": e }) }} />
                    </div> */}
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={ImportDeclaration.bean.NoDocTransport} onChange={ImportDeclaration.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de declaración de Importación</label>
                        <input type="text" name="NoDeclartionImportDM" className="form-control" value={ImportDeclaration.bean.NoDeclartionImportDM} onChange={ImportDeclaration.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={ImportDeclaration.bean.CurrencyType} onchange={(e: any) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={ImportDeclaration.bean.MadeByDM} label="usuario/persona que elabora la declaracion de importación" onChange={(acc: any) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, "MadeByDM": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={ImportDeclaration.bean.ReviewedByDM} label="usuario/persona que revisa la declaracion de importación" onChange={(acc: any) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, "ReviewedByDM": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="ObservationsDM" className="form-control" value={ImportDeclaration.bean.ObservationsDM} onChange={(e) => { ImportDeclaration.setBean({ ...ImportDeclaration.bean, 'ObservationsDM': e.target.value }) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={editaItem}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {ImportDeclaration.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">
                            {/* <PrintJson json={costestudy.bean} /> */}
                            <NationalizationProcessItemsByImportDM IDNationalizationProcessGeneralInfo={ImportDeclaration.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}